<template>
  <div class="pills-container">
    <span v-for="(item, idx) in items" :key="idx" class="badge pill" :class="customClass">
      {{ item }}
      <button type="button" class="btn-close ms-2 custom-close" aria-label="Remove" @click="removePill(item)"></button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  emits: ['remove'],
  methods: {
    removePill(item) {
      this.$emit('remove', item)
    }
  }
}
</script>
<style scoped>
.pills-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.pill {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}
.custom-close {
  width: 4px; /* Adjust size */
  height: 4px;
  font-weight: bold;
  color: white;
  opacity: 1;
  filter: invert(1); /* Ensures white color on dark backgrounds */
}
/* .custom-close::before {
  content: '×'; 
  font-size: 16px;
  font-weight: bold;
  color: white;
} */
</style>
